import React from "react";
import { ISession } from "../../../types/message";
import { BasicDetailsTypes } from "../../../types/profile";

interface StatusProps {
  chatUserDetails: BasicDetailsTypes;
  session: ISession | undefined;
}
const Status = ({ chatUserDetails, session }: StatusProps) => {

  return (
    <div className="text-muted pt-4">
      <h5 className="font-size-11 text-uppercase">Sessão: {session?.id}</h5>
      <h5 className="font-size-11 text-uppercase">Identificador: {chatUserDetails?.idCliente}</h5>
      <h5 className="font-size-11 text-uppercase">CPF: {chatUserDetails?.cpfCnpj}</h5>

      <h5 className="font-size-11 text-uppercase">Visita: {chatUserDetails?.dataVisita}</h5>
      <h5 className="font-size-11 text-uppercase">{chatUserDetails?.obsVisita}</h5>
      <p className="mb-4"></p>
    </div>
  );
};

export default Status;
